import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useEnvironmentStore = defineStore('environment', () => {
  const environmentName = ref<string>('');
  const configCache = ref<Record<string, unknown>>({});
  // WI 2426: er gjeldende miljø klassifisert som produksjon? Trygg standard = true (prod),
  // slik at ikke-prod-funksjoner (per-opplasting-overstyring, WI 2425/2430) aldri vises før
  // /api/config eksplisitt sier ikke-prod.
  const isProduction = ref<boolean>(true);

  function setEnvironmentName (name: string) {
    environmentName.value = name;
  }
  function setConfigCache (cache: Record<string, unknown>) {
    configCache.value = cache;
  }
  function setIsProduction (value: boolean) {
    isProduction.value = value;
  }

  return {
    environmentName,
    configCache,
    isProduction,
    setEnvironmentName,
    setConfigCache,
    setIsProduction,
  };
});
